import React from "react";
import { Tab } from "semantic-ui-react";
import Questions from "features/FolderManager/components/Questions";
import EditPostIt from "features/FolderManager/components/SidebarComp/EditPostIt";

const QuestionsContent = ({
	mode,
	disabled,
	data,
	userIsSecretary,
	onQuestionsSubmit,
	user,
	setFormStatus,
	setQuestionErrors,
	prevalidFolders,
	openSidebar,
	formStatus,
	formikRef,
	setFormikRef,
	setQuestionsDataToUpdate,
	questionsDataToUpdate,
	isForMotivationContent,
	setMotivationsErrors,
}) => {
	const getMotivationsQuestions = (questions) => {
		//Only display motivations questions MARQTUM if more than 2
		let hasMoreThanTwoMarqTum =
			questions.flatMap((q) =>
				q.questions
					.filter(
						(q) => q.question && q.question.motivation && q.question.sil_code === "MARQTUM-M01" && q.links.reduce((sum, a) => sum + a.weight, 0) > 2
					)
					.map((q) => q.question)
			).length > 0;
		//Only display motivations questions Serologies if more than 12
		let hasMoreThanTwelvePregnantSero =
			data.patient.gender === "f" &&
			questions.flatMap((q) =>
				q.questions
					.filter(
						(q) => q.question && q.question.motivation && q.question.sil_code === "SEROINF-M01" && q.links.reduce((sum, a) => sum + a.weight, 0) > 12
					)
					.map((q) => q.question)
			).length > 0;
		let result = questions
			.filter(
				(q) =>
					q.questions &&
					q.questions.some((q) => q.question.motivation) &&
					(hasMoreThanTwoMarqTum || q.questions.some((q) => q.question && q.question.motivation && q.question.sil_code !== "MARQTUM-M01")) &&
					(hasMoreThanTwelvePregnantSero || q.questions.some((q) => q.question && q.question.motivation && q.question.sil_code !== "SEROINF-M01"))
			)
			.map((q) => {
				return {
					...q,
					questions: q.questions.filter((q) => q.question.motivation),
				};
			});
		return result;
	};

	const getQuestions = (isSecretary, questions) => {
		let result = isSecretary
			? questions
					.filter((q) => q.questions && q.questions.filter((q) => q.question && !q.question.motivation && q.question.target !== "NURSE").length > 0)
					.map((q) => {
						return { ...q, questions: q.questions.filter((q) => q.question && !q.question.motivation) };
					})
			: questions
					.filter((q) => q.questions && q.questions.filter((q) => q.question && !q.question.motivation).length > 0)
					.map((q) => {
						return { ...q, questions: q.questions.filter((q) => q.question && !q.question.motivation) };
					});
		return result;
	};
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<Questions
				data={{
					questions: isForMotivationContent ? getMotivationsQuestions(data.questions) : getQuestions(userIsSecretary, data.questions),
					systematic_questions: isForMotivationContent
						? []
						: userIsSecretary
						? data.systematic_questions.filter((q) => q.questions.filter((q) => q.question.target !== "NURSE").length > 0)
						: data.systematic_questions,
				}}
				onQuestionsSubmit={onQuestionsSubmit}
				patient={data.patient}
				user={user}
				setFormikRef={setFormikRef}
				formikRef={formikRef}
				setFormStatus={setFormStatus}
				setQuestionErrors={setQuestionErrors}
				prevalidFolders={prevalidFolders}
				formStatus={formStatus && data.infos.questionAnswersSaved}
				onPostItEdit={(e) => {
					if (e !== undefined) e.preventDefault();
					openSidebar(<EditPostIt onSubmit={this.editPostIt} patient={data.patient} hideSidebar={this.props.hideSidebar} />);
				}}
				disabled={disabled}
				mode={mode}
				setQuestionsDataToUpdate={setQuestionsDataToUpdate}
				questionsDataToUpdate={questionsDataToUpdate}
				setMotivationsErrors={setMotivationsErrors}
				isMotivation={isForMotivationContent}
			/>
		</Tab.Pane>
	);
};
export default QuestionsContent;
